/**
 * @generated SignedSource<<f4135759f3e683cfc040a679986d940b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion$data = {
  readonly issueCount: number;
  readonly " $fragmentType": "TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion";
};
export type TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion$key = {
  readonly " $data"?: TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "issueCount",
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "e87c904f1ba3146f69d3892b9658b7ea";

export default node;
